/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGlobalState } from './global';

const initialState: IGlobalState = {
  showLoginDialog: false,
  showSignupDialog: false,
  showForgetPasswordDialog: false,
  showFeedSheet: false,
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setShowLoginDialog: (state, action: PayloadAction<boolean>) => {
      state.showLoginDialog = action.payload;
    },
    setShowSignupDialog: (state, action: PayloadAction<boolean>) => {
      state.showSignupDialog = action.payload;
    },
    setShowForgetPasswordDialog: (state, action: PayloadAction<boolean>) => {
      state.showForgetPasswordDialog = action.payload;
    },
    setShowFeedSheet: (state, action: PayloadAction<boolean>) => {
      state.showFeedSheet = action.payload;
    },
  },
});

export const {
  setShowLoginDialog,
  setShowSignupDialog,
  setShowForgetPasswordDialog,
  setShowFeedSheet,
} = globalSlice.actions;

export default globalSlice.reducer;
